import * as queryString from "query-string";
import { addNetworkElementPayload, editNetworkElementPayload, GetNodeWiseNrPayload } from "../interfaces/dashboard.interface";
import { API_PATHS_NEW, ApiPath } from "../utils/apiConstants";
import { getAuthHeader } from "../utils/methods";
import http from "../httpConfig";
const getNodeWiseNr = (payload: GetNodeWiseNrPayload) => {
  return http.post(ApiPath.networkResources + ApiPath.nodeWiseNr, payload, { headers: getAuthHeader() });
};

const getSelectedNodes = () => {
  return http.get(ApiPath.users + ApiPath.selectedNode, { headers: getAuthHeader() });
};

const getCanvasData = () => {
  return http.get(ApiPath.users + ApiPath.canvasPosition, { headers: getAuthHeader() });
};

const getAboutMenus = () => {
  return http.get(ApiPath.aboutMenus, { headers: getAuthHeader() });
};

const putCanvasData = (payload: any) => {
  const reqBody = {
    canvasPosition: payload,
  };
  return http.put(ApiPath.users + ApiPath.updateCanvasPosition, reqBody, { headers: getAuthHeader() });
};

const addNetworkElement = (payload: addNetworkElementPayload) => {
  return http.post(ApiPath.addNE, payload, { headers: getAuthHeader() });
};

const editNetworkElement = (payload: editNetworkElementPayload) => {
  return http.post(ApiPath.editNE, payload, { headers: getAuthHeader() });
};

const getCrossConnectActionRequired = (payload: { nrId1: number; nrId2: number }) => {
  const url = queryString.stringifyUrl({ url: API_PATHS_NEW.crossConnectActionRequired, query: payload });
  return http.get(url, { headers: getAuthHeader() });
};

const saveUserCanvasPosition = (payload: any) => {
  const reqBody = {
    savedCanvasPosition: payload,
  };
  return http.put(ApiPath.users + ApiPath.saveCanvasPosition, reqBody, { headers: getAuthHeader() });
};

const getSavedCanvasData = () => {
  return http.get(ApiPath.users + ApiPath.getSavedCanvasPosition, { headers: getAuthHeader() });
}

const clearSavedCanvasData = () => {
  return http.delete(ApiPath.users + ApiPath.clearSavedCanvasPosition, { headers: getAuthHeader() });
}

const DashboardService = {
  getNodeWiseNr,
  getSelectedNodes,
  getCanvasData,
  putCanvasData,
  getAboutMenus,
  addNetworkElement,
  editNetworkElement,
  getCrossConnectActionRequired,
  saveUserCanvasPosition,
  getSavedCanvasData,
  clearSavedCanvasData
};

export default DashboardService;
